import type { CreateSourceState } from "@/pages/sources/components/create/sources/types";

export enum TextPhase {
  IDLE = "IDLE",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export type CreateSourceTextState = CreateSourceState & {
  textContent: string;
  phase: TextPhase;
};
